const actions = {

    ABOUT_INFO_DATA_BEGIN : 'ABOUT_INFO_DATA_BEGIN',
    ABOUT_INFO_DATA_SUCCESS: 'ABOUT_INFO_DATA_SUCCESS',
    ABOUT_INFO_DATA_ERR : 'ABOUT_INFO_DATA_ERR',

    ABOUT_INFO_PPT_LIST_DATA_BEGIN: 'ABOUT_INFO_PPT_LIST_DATA_BEGIN',
    ABOUT_INFO_PPT_LIST_DATA_SUCCESS: 'ABOUT_INFO_PPT_LIST_DATA_SUCCESS',
    ABOUT_INFO_PPT_LIST_DATA_ERR : 'ABOUT_INFO_PPT_LIST_DATA_ERR',
    ABOUT_INFO_PPT_LIST_DATA_RESET: 'ABOUT_INFO_PPT_LIST_DATA_RESET',

    ABOUT_INFO_PPT_DETAILS_DATA_BEGIN : 'ABOUT_INFO_PPT_DETAILS_DATA_BEGIN',
    ABOUT_INFO_PPT_DETAILS_DATA_SUCCESS: 'ABOUT_INFO_PPT_DETAILS_DATA_SUCCESS',
    ABOUT_INFO_PPT_DETAILS_DATA_ERR : 'ABOUT_INFO_PPT_DETAILS_DATA_ERR',
    ABOUT_INFO_PPT_DETAILS_DATA_RESET: 'ABOUT_INFO_PPT_DETAILS_DATA_RESET',

    ABOUT_GET_EXCHANGE_DATA_BEGIN: 'ABOUT_GET_EXCHANGE_DATA_BEGIN',
    ABOUT_GET_EXCHANGE_DATA_SUCCESS: 'ABOUT_GET_EXCHANGE_DATA_SUCCESS',
    ABOUT_GET_EXCHANGE_DATA_ERR: 'ABOUT_GET_EXCHANGE_DATA_ERR',
    ABOUT_GET_EXCHANGE_DATA_RESET:'ABOUT_GET_EXCHANGE_DATA_RESET',

    ABOUT_HISTORY_DETAILS_BEGIN: 'ABOUT_HISTORY_DETAILS_BEGIN',
    ABOUT_HISTORY_DETAILS_SUCCESS: 'ABOUT_HISTORY_DETAILS_SUCCESS',
    ABOUT_HISTORY_DETAILS_ERR: 'ABOUT_HISTORY_DETAILS_ERR',

    ABOUT_VIEW_DETAILS_BEGIN: 'ABOUT_VIEW_DETAILS_BEGIN',
    ABOUT_VIEW_DETAILS_SUCCESS: 'ABOUT_VIEW_DETAILS_SUCCESS',
    ABOUT_VIEW_DETAILS_ERR: 'ABOUT_VIEW_DETAILS_ERR',

    ABOUT_FBO_HISTORY_DETAILS_BEGIN: 'ABOUT_FBO_HISTORY_DETAILS_BEGIN',
    ABOUT_FBO_HISTORY_DETAILS_SUCCESS: 'ABOUT_FBO_HISTORY_DETAILS_SUCCESS',
    ABOUT_FBO_HISTORY_DETAILS_ERR: 'ABOUT_FBO_HISTORY_DETAILS_ERR',

    ABOUT_FBO_VIEW_DETAILS_BEGIN: 'ABOUT_FBO_VIEW_DETAILS_BEGIN',
    ABOUT_FBO_VIEW_DETAILS_SUCCESS: 'ABOUT_FBO_VIEW_DETAILS_SUCCESS',
    ABOUT_FBO_VIEW_DETAILS_ERR: 'ABOUT_FBO_VIEW_DETAILS_ERR',

    ABOUT_START_TOKEN_BEGIN: 'ABOUT_START_TOKEN_BEGIN',
    ABOUT_START_TOKEN_SUCCESS: 'ABOUT_START_TOKEN_SUCCESS',
    ABOUT_START_TOKEN_ERR: 'ABOUT_START_TOKEN_ERR',
    ABOUT_START_TOKEN_RESET:'ABOUT_START_TOKEN_RESET',

    SUBMIT_MISSING_PPT_INFO_DATA_BEGIN: 'SUBMIT_MISSING_PPT_INFO_DATA_BEGIN',
    SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS: 'SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS',
    SUBMIT_MISSING_PPT_INFO_DATA_ERR: 'SUBMIT_MISSING_PPT_INFO_DATA_ERR',
    SUBMIT_MISSING_PPT_INFO_DATA_RESET: 'SUBMIT_MISSING_PPT_INFO_DATA_RESET',

    SUBMIT_PPT_INFO_DATA_BEGIN: 'SUBMIT_PPT_INFO_DATA_BEGIN',
    SUBMIT_PPT_INFO_DATA_SUCCESS: 'SUBMIT_PPT_INFO_DATA_SUCCESS',
    SUBMIT_PPT_INFO_DATA_ERR: 'SUBMIT_PPT_INFO_DATA_ERR',
    SUBMIT_PPT_INFO_DATA_RESET: 'SUBMIT_PPT_INFO_DATA_RESET',

    ABOUT_EXCHNAGE_PRICE_BEGIN: 'ABOUT_EXCHNAGE_PRICE_BEGIN',
    ABOUT_EXCHNAGE_PRICE_SUCCESS: 'ABOUT_EXCHNAGE_PRICE_SUCCESS',
    ABOUT_EXCHNAGE_PRICE_ERR: 'ABOUT_EXCHNAGE_PRICE_ERR',
    ABOUT_EXCHNAGE_PRICE_RESET: 'ABOUT_EXCHNAGE_PRICE_RESET',
    
    
    getAboutInfoDataBegin: () => {
        return {
            type: actions.ABOUT_INFO_DATA_BEGIN,
        };
    },

    getAboutInfoDataSuccess: (data) => {
        return {
            type: actions.ABOUT_INFO_DATA_SUCCESS,
            data,
        };
    },

    getAboutInfoDataErr: (err) => {
        return {
            type: actions.ABOUT_INFO_DATA_ERR,
            err,
        };
    },

    getPPTInfoListDataBegin : () => {
        return {
            type: actions.ABOUT_INFO_PPT_LIST_DATA_BEGIN,
        };
    },

    getPPTInfoListDataSuccess : (data) => {
        return {
            type: actions.ABOUT_INFO_PPT_LIST_DATA_SUCCESS,
            data,
        };
    },

    getPPTInfoListDataErr : (err) => {
        return {
            type: actions.ABOUT_INFO_PPT_LIST_DATA_ERR,
            err,
        };
    },

    getPPTInfoListDataReset : () => {
        return {
            type: actions.ABOUT_INFO_PPT_LIST_DATA_RESET,
        };
    },

    getPPTInfoDetailsDataBegin : () => {
        return {
            type: actions.ABOUT_INFO_PPT_DETAILS_DATA_BEGIN,
        };
    },

    getPPTInfoDetailsDataSuccess : (data) => {
        return {
            type: actions.ABOUT_INFO_PPT_DETAILS_DATA_SUCCESS,
            data,
        };
    },

    getPPTInfoDetailsDataErr : (err) => {
        return {
            type: actions.ABOUT_INFO_PPT_DETAILS_DATA_ERR,
            err,
        };
    },

    getPPTInfoDetailsDataReset : () => {
        return {
            type: actions.ABOUT_INFO_PPT_DETAILS_DATA_RESET,
        };
    },

    submitPPTInfomationDataBegin : () => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_BEGIN,
        };
    },

    submitPPTInfomationDataSuccess : (data) => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_SUCCESS,
            data,
        };
    },

    submitPPTInfomationDataErr : (err) => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_ERR,
            err,
        };
    },

    submitPPTInfomationDataReset : () => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_RESET,
        };
    },

    getExchangeDetailsBegin : () => {
        return{
            type: actions.ABOUT_GET_EXCHANGE_DATA_BEGIN,
        }
    },

    getExchangeDetailsSuccess : (data) => {
        return {
            type: actions.ABOUT_GET_EXCHANGE_DATA_SUCCESS,
            data,
        };
    },

    getExchangeDetailsErr : (err) => {
        return {
            type: actions.ABOUT_GET_EXCHANGE_DATA_ERR,
            err,
        };
    },
    getExchangeDetailsReset : () => {
        return {
            type: actions.ABOUT_GET_EXCHANGE_DATA_RESET,
        };
    },

    submitMissingPPTBegin : () => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_BEGIN,
        };
    },

    submitMissingPPTSuccess : (data) => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS,
            data,
        };
    },

    submitMissingPPTErr : (err) => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_ERR,
            err,
        };
    },

    submitMissingPPTReset : () => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_RESET,
        };
    },

    getHistoryDetailsBegin : () => {
        return {
            type: actions.ABOUT_HISTORY_DETAILS_BEGIN,
        };
    },

    getHistoryDetailsSuccess : (data) => {
        return {
            type: actions.ABOUT_HISTORY_DETAILS_SUCCESS,
            data,
        };
    },

    getHistoryDetailsErr : (err) => {
        return {
            type: actions.ABOUT_HISTORY_DETAILS_ERR,
            err,
        };
    },
    getHistoryViewDetailsBegin : ()=>{
        return {
            type: actions.ABOUT_VIEW_DETAILS_BEGIN
        }
    },
    getHistoryViewDetailsSuccess : (data)=>{
        return {
            type: actions.ABOUT_VIEW_DETAILS_SUCCESS,
            data
        }
    },
    getHistoryViewDetailsErr : (err)=>{
        return {
            type: actions.ABOUT_VIEW_DETAILS_ERR,
            err
        }
    },

    getFBOHistoryDetailsBegin : () => {
        return {
            type: actions.ABOUT_FBO_HISTORY_DETAILS_BEGIN,
        };
    },

    getFBOHistoryDetailsSuccess : (data) => {
        return {
            type: actions.ABOUT_FBO_HISTORY_DETAILS_SUCCESS,
            data,
        };
    },

    getFBOHistoryDetailsErr : (err) => {
        return {
            type: actions.ABOUT_FBO_HISTORY_DETAILS_ERR,
            err,
        };
    },
    getFBOHistoryViewDetailsBegin : ()=>{
        return {
            type: actions.ABOUT_FBO_VIEW_DETAILS_BEGIN
        }
    },
    getFBOHistoryViewDetailsSuccess : (data)=>{
        return {
            type: actions.ABOUT_FBO_VIEW_DETAILS_SUCCESS,
            data
        }
    },
    getFBOHistoryViewDetailsErr : (err)=>{
        return {
            type: actions.ABOUT_FBO_VIEW_DETAILS_ERR,
            err
        }
    },

    postStartTokenBegin : () => {
        return{
            type: actions.ABOUT_START_TOKEN_BEGIN,
        }
    },

    postStartTokenSuccess : (data) => {
        return {
            type: actions.ABOUT_START_TOKEN_SUCCESS,
            data,
        };
    },

    postStartTokenErr : (err) => {
        return {
            type: actions.ABOUT_START_TOKEN_ERR,
            err,
        };
    },
    postStartTokenReset : () => {
        return {
            type: actions.ABOUT_START_TOKEN_RESET,
        };
    },
     postExchnagePriceBegin : () => {
        return{
            type: actions.ABOUT_EXCHNAGE_PRICE_BEGIN,
        }
    },

    postExchnagePriceSuccess : (data) => {
        return {
            type: actions.ABOUT_EXCHNAGE_PRICE_SUCCESS,
            data,
        };
    },

    postExchnagePriceErr : (err) => {
        return {
            type: actions.ABOUT_EXCHNAGE_PRICE_ERR,
            err,
        };
    },
    postExchnagePriceReset : () => {
        return {
            type: actions.ABOUT_EXCHNAGE_PRICE_RESET,
        };
    },
};

export default actions;
